import actions from './actions'

export default function Invoice2ItemsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      console.log('REDUCERINVOICE2ITEM REQUESTING Invoice2ItemsReducer', action)
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_INVOICE2ITEM:
      console.log('REDUCERINVOICE2ITEM LIST_INVOICE2ITEM', action)
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_INVOICE2ITEM:
      console.log('EDIT_INVOICE2ITEM', action)
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_INVOICE2ITEM:
      console.log('REDUCERINVOICE2ITEM RESET_INVOICE2ITEM')
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_INVOICE2ITEM:
      return {
        ...state,
        editing: { Invoice2ItemID: 0, invoiceID: action.invoiceID },
        loading: false,
        saveSuccess: false,
      }
    case actions.SAVE_INVOICE2ITEM_RECIEVED:
      return {
        ...state,
        editing: { Invoice2ItemID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.DELETE_INVOICE2ITEM_RECIEVED:
      console.log('DELETE_INVOICE2ITEM_RECIEVED')
      return {
        ...state,
        editing: { Invoice2ItemID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      console.error(
        'REDUCERINVOICE2ITEM Error in Invoice2ItemsReducer RESPONSE_ERROR:',
        action.message,
      )
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }

    default:
      return state
  }
}
